// Add your custom JS here


(function($) {




    $('section.related.products').addClass('carousel').find('ul.products').addClass('carousel-inner').find('li.product').addClass('carousel-item');

    //$('.carousel').carousel();

    var showTotalsInCart = function() {

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }



        var cartMenu = $('.menu-item-cart a');
        cartMenu.find('span').remove();

        var cartHash = readCookie('woocommerce_cart_hash');
        if(null !== cartHash) {
            $.get('/wp-json/cocart/v2/cart', function(data) {
                cartMenu.append('<span class="qty">' + data.item_count
                    //+ ' item' + (data.item_count > 1 ? 's' : '')
                    +'</span>');
                    //.append('<span class="subtotal">'
                    //    + new Intl.NumberFormat('en-GB', {style:'currency', currency:'GBP'}).format(data.totals.subtotal / 100)
                    //    + '</span>');
            });
        }

    }
    showTotalsInCart();

    // Relabel MSRP as RRP
    $('.woocommerce label[for="alg_wc_msrp"]').text('RRP');
    //
    $('a[href^="#heading-"]').on('click', function(e){
        e.preventDefault();
        //
        var link = $(this).attr('href');
        var linkOffset = $(link).offset().top;
        //
        $('html, body').animate({
            scrollTop:linkOffset
        }, 'slow');
    });
    //
    const $shopList = $(".club-shop-list");
    const $shops = $shopList.children("li");
    $('.club-shops a.btn').on('click', function(e){
        e.preventDefault();
        //
        const letter = $(this).data("letter"); // Get the letter from the button's data attribute

        // Filter shops that start with the selected letter
        const filteredShops = $shops.filter(function () {
            const shopName = $(this).find('h4').text()?.trim();
            return shopName && shopName.toUpperCase().startsWith(letter);
        });

        // Update the shop list with the filtered items
        $shopList.empty().append(filteredShops);
    });
    //
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if ($('.woof_container_product_cat .woof_list .woof_childs_list_li').length) {
                $('.woof_container_product_cat .woof_list .woof_childs_list_li').each(function() {
                    // Find the <span> with class 'woof_is_opened' inside the current <li>
                    var openedSpan = $(this).find('span.woof_is_opened');
                    var childList = $(this).find('ul.woof_childs_list');
                
                    // If the <span> exists, change its class to 'woof_is_closed'
                    if (openedSpan.length) {
                        openedSpan.removeClass('woof_is_opened').addClass('woof_is_closed');
                    }
                    //
                    if (childList.length) {
                        childList.hide();
                    }
                });
                observer.disconnect(); // Stop observing after the element is found
            }
        });
    });
    // Start observing the DOM
    observer.observe(document.body, { childList: true, subtree: true });


})(jQuery);// Add your custom JS here.